import { useEffect } from 'react';

export default function useOnClickOutside(
  ref: any,
  handler: any,
  openDrawer: boolean,
  openDrawerFilter: boolean
) {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      const screenWidth = window.innerWidth;
      const clickXPosition = event.clientX;

      if (openDrawer && openDrawerFilter && clickXPosition > screenWidth - 380) {
        return;
      }

      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, openDrawer, openDrawerFilter]);
}
